import { render, staticRenderFns } from "./TemplateGroupsForm.vue?vue&type=template&id=9cab0af6&scoped=true"
import script from "./TemplateGroupsForm.vue?vue&type=script&lang=js"
export * from "./TemplateGroupsForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateGroupsForm.vue?vue&type=style&index=0&id=9cab0af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cab0af6",
  null
  
)

export default component.exports